import { Link } from "wouter";
import { PageShell } from "@/components/Shell";

export default function NotFound() {
  return (
    <PageShell>
      <div className="card-shell p-8 max-w-xl">
        <div className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground mb-1.5">
          404
        </div>
        <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
        <Link href="/" className="text-sm underline text-muted-foreground hover:text-foreground mt-4 inline-block">
          Back to accounts
        </Link>
      </div>
    </PageShell>
  );
}
